"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { DefaultSingleWaveDrop } from "./DefaultSingleWaveDrop";
import type { SingleWaveDropProps } from "../drops/participation/participationRenderer.types";
export const QuorumSingleWaveDrop: React.FC<SingleWaveDropProps> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <DefaultSingleWaveDrop {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};